export default __webpack_public_path__ + "static/media/productDefault.af8c6723.png";